import * as Store from '../store/index.js';
import * as Bridge from '../../../engine/sync/crdt-bridge.js';
import { createModal, showModal, closeModal } from './modals.js';
import { on, Events } from '../../../engine/core/events.js';
import { dayKey, addDays } from '../../../engine/core/recurrence.js';
import { escapeHtml } from '../../../engine/core/validation.js';
import { t, tHtml } from '../../../shared/i18n/index.js';

let initialized = false;
export function initTaskPostponement({ onChange = () => {} } = {}) {
  if (initialized) return;
  initialized = true;
  let queued = false, previousEvents = null;
  const refresh = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => {
      queued = false;
      try { Bridge.returnDueTasks(); }
      catch (error) { console.warn('[Tasks] Return dates retained; retrying when storage is available.', error); }
      const events = JSON.stringify([Store.get('currentDocId'), Bridge.getTaskPostponementEvents()]);
      if (events !== previousEvents) { previousEvents = events; onChange(); }
    });
  };
  for (const event of [Events.DATA_LOADED, Events.EXECUTION_CHANGED, Events.DOC_NOTES_CHANGED,
    Events.CRDT_PROJECTION_UPDATED, Events.QUOTA_CHANGED]) on(event, refresh);
  // Covers midnight, reopening a suspended tab and opening a map after days away.
  setInterval(refresh, 60000);
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  Store.subscribe((state, old) => {
    if (state.currentDocId !== old.currentDocId) { closeModal('task-postpone'); refresh(); }
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-task-postpone]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation();
    openTaskPostponement(button.dataset.taskPostpone);
  });
  refresh();
}
export function openTaskPostponement(nodeId) {
  if (!Bridge.canPostponeTask(nodeId)) return;
  const docId = Store.get('currentDocId');
  const pending = Bridge.getTaskPostponement(nodeId);
  closeModal('task-postpone');
  document.getElementById('task-postpone')?.remove();
  const modal = createModal({ id: 'task-postpone', title: t('routines.postpone.title'), className: 'task-postpone-modal',
    content: `<p>${escapeHtml(Store.find(nodeId)?.name || t('common.untitled'))}</p>
      <p>${escapeHtml(t('routines.postpone.intro'))}</p>
      ${pending ? `<p>${tHtml('routines.postpone.currently', {}, { date: `<strong>${escapeHtml(pending.until)}</strong>` })}</p>` : ''}
      <div class="task-postpone-days">${Array.from({length:7}, (_,i)=>`<button type="button" class="modal-btn modal-btn-secondary" data-postpone-days="${i+1}">${escapeHtml(t('routines.daysShort', { n: String(i+1) }))}</button>`).join('')}</div>
      <form id="task-postpone-form"><label for="task-postpone-date">${escapeHtml(t('routines.postpone.orDate'))}</label>
        <input id="task-postpone-date" type="date" required min="${addDays(dayKey(),1)}" value="${pending?.until || addDays(dayKey(),1)}">
        <button type="submit" class="modal-btn modal-btn-primary">${escapeHtml(t('routines.postpone.submit'))}</button>
      </form>
      ${pending ? `<button type="button" class="modal-btn modal-btn-secondary" data-postpone-now>${escapeHtml(t('routines.postpone.bringBack'))}</button>` : ''}
      <p class="task-postpone-error" role="alert"></p>` });
  const apply = day => {
    try {
      if (Store.get('currentDocId') !== docId) throw new Error(t('routines.postpone.otherMap'));
      if (day === null) Bridge.bringTaskBack(nodeId);
      else Bridge.postponeTask(nodeId, day);
      closeModal('task-postpone');
    } catch (error) { modal.querySelector('[role="alert"]').textContent = error.message; }
  };
  modal.querySelectorAll('[data-postpone-days]').forEach(button => button.onclick = () => apply(addDays(dayKey(),Number(button.dataset.postponeDays))));
  modal.querySelector('form').onsubmit = event => { event.preventDefault(); apply(modal.querySelector('input').value); };
  modal.querySelector('[data-postpone-now]')?.addEventListener('click', () => apply(null));
  void showModal(modal);
}
